import axiosInstance from '../../../../config/axiosInstance';
import { AssetSubCategoryValidation } from "../../views/AssetSubCategory/Validation/AssetSubCategoryValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = AssetSubCategoryValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateAssetSubCategory`, formData);
      setFormData({
        AssetCategoryID: '',
        SubCategoryName:'',
        dec_DepRate:'',
        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };